// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { StudentPurchasedItemRepresentation } from './StudentPurchasedItemRepresentation'
import {
  StudentPurchasedItemRepresentationFromJSON,
  StudentPurchasedItemRepresentationFromJSONTyped,
  StudentPurchasedItemRepresentationToJSON,
} from './StudentPurchasedItemRepresentation'

/**
 *
 * @export
 * @interface StudentPurchasedItemRepresentationBaseApiListResult
 */
export interface StudentPurchasedItemRepresentationBaseApiListResult {
  /**
   *
   * @type {Array<StudentPurchasedItemRepresentation>}
   * @memberof StudentPurchasedItemRepresentationBaseApiListResult
   */
  data: Array<StudentPurchasedItemRepresentation>
  /**
   *
   * @type {number}
   * @memberof StudentPurchasedItemRepresentationBaseApiListResult
   */
  total: number
}

/**
 * Check if a given object implements the StudentPurchasedItemRepresentationBaseApiListResult interface.
 */
export function instanceOfStudentPurchasedItemRepresentationBaseApiListResult(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'data' in value
  isInstance = isInstance && 'total' in value

  return isInstance
}

export function StudentPurchasedItemRepresentationBaseApiListResultFromJSON(
  json: any,
): StudentPurchasedItemRepresentationBaseApiListResult {
  return StudentPurchasedItemRepresentationBaseApiListResultFromJSONTyped(
    json,
    false,
  )
}

export function StudentPurchasedItemRepresentationBaseApiListResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentPurchasedItemRepresentationBaseApiListResult {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: (json['data'] as Array<any>).map(
      StudentPurchasedItemRepresentationFromJSON,
    ),
    total: json['total'],
  }
}

export function StudentPurchasedItemRepresentationBaseApiListResultToJSON(
  value?: StudentPurchasedItemRepresentationBaseApiListResult | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: (value.data as Array<any>).map(
      StudentPurchasedItemRepresentationToJSON,
    ),
    total: value.total,
  }
}
